import { IGetQuotationResponse } from "../models/User";

export function convertQuotation(data: any): IGetQuotationResponse {
  return data.map((quotation: any) => ({
    id: quotation.id,
    refNo: quotation.stock.refNo,
    displayName: quotation.stock.displayName,
    category: quotation.category,
    withCatalyst: quotation.withCatalyst,
    price: Number(quotation.price),
    isSold: quotation.stock.isSold,
    soldDate: quotation.soldDate,
    isPurchased: quotation.isPurchased,
    loadingPorts: quotation.stock.loadingPorts.map((loadingPort: any) => ({
      id: loadingPort.id,
      transportationFee: Number(loadingPort.transportationFee),
    })), 
  }))
}